export default __webpack_public_path__ + "static/media/not_found.8ddf4849.png";